var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "lookup--section section--card",
    class: _vm.dark && 'dark'
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "section--content"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "subtitle sm-md:hidden"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.loaded && _vm.result ? _c('span', {
    key: "match"
  }, [_vm._v("Your bank connects with Extra 🎉")]) : _vm.loaded && !_vm.result ? _c('span', {
    key: "nomatch"
  }, [_vm._v("Your bank does not connect with Extra at the moment 🥺")]) : _c('span', {
    key: "base"
  }, [_vm._v("Over 10,000+ Banks are connected with Extra")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mx-auto wrapper"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [!_vm.loaded ? _c('input', {
    class: {
      'color-mint': _vm.result
    },
    attrs: {
      "_list": "browsers",
      "placeholder": "Search your bank here...",
      "type": "search",
      "autocomplete": "off",
      "name": "bankLookup"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:query', $event.target.value);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.lookupBank.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.loaded && _vm.result ? _c('div', {
    staticClass: "lookup--icon-container sm-md:-mt-1",
    class: {
      'lookup--success': _vm.animate,
      'lookup--has-logo': _vm.result.logo
    }
  }, [_vm.result.logo ? _c('img', {
    attrs: {
      "src": `data:image/png;base64,${_vm.result.logo}`,
      "alt": _vm.result.name
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "lookup--check-icon",
    class: {
      'lookup--has-logo': !!_vm.result.logo
    },
    attrs: {
      "src": require("assets/images/lookup-match.svg")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center w-full sm-md:-mt-5"
  }, [_vm.loaded && !_vm.result ? _c('img', {
    staticClass: "lookup--check-icon",
    attrs: {
      "src": require("assets/images/lookup-no-match.svg")
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mx-auto btn-wrapper"
  }, [_c('button', {
    key: "search",
    class: [_vm.loaded && 'filled'],
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.btn
    }
  }, [!_vm.loaded ? _c('img', {
    attrs: {
      "width": "18px",
      "src": require("assets/images/bank--search.png")
    }
  }) : _c('img', {
    attrs: {
      "width": "20px",
      "src": require("assets/images/bank--reset.png")
    }
  })])])], 1)]), _vm._v(" "), _vm.dark ? _c('img', {
    staticClass: "hidden mx-auto mt-4 sm-md:block lookup--plaid sm-md:mt-2",
    attrs: {
      "src": require("assets/images/lookup-pwd-plaid-light.svg")
    }
  }) : _c('img', {
    staticClass: "hidden mx-auto mt-4 sm-md:block lookup--plaid sm-md:mt-2",
    attrs: {
      "src": require("assets/images/lookup-pwd-plaid.svg")
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "pb-6 sm-md:pb-3 title"
  }, [_vm._v("Does Extra Connect"), _c('br'), _vm._v("with My Bank?")]);
}];
export { render, staticRenderFns };